import React, { useEffect, useState } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import SocialIcon from './Components/Social Icon/SocialIcon';
import ContactForm from './Components/Contact/ContactForm';
import AboutUs from './Components/AboutUs/AboutUs';
import Body from './Components/Body/Body';
import Faq from './Components/Faq/Faq';
import BlogSection from './Components/BlogSection/BlogSection';
import BlogDetails from './Components/BlogSection/BlogDetails';
import Preloader from './Components/Preloader/Preloader'; // ✅ Add this line

const App = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2500);
    return () => clearTimeout(timer);
  }, []);

  const router = createBrowserRouter([
    {
      path: '/',
      element: (
        <>
          <Header /> <Body /> <Footer /> <SocialIcon />
        </>
      ),
    },
    {
      path: '/home',
      element: (
        <>
          <Header /> <Body /> <Footer /> <SocialIcon />
        </>
      ),
    },
    {
      path: '/about-us',
      element: (
        <>
          <Header /> <AboutUs /> <Footer /> <SocialIcon />
        </>
      ),
    },
    {
      path: '/contact-us',
      element: (
        <>
          <Header /> <ContactForm /> <Footer /> <SocialIcon />
        </>
      ),
    },
    {
      path: '/blogs',
      element: (
        <>
          <Header /> <BlogSection /> <Footer /> <SocialIcon />
        </>
      ),
    },
    {
      path: '/blog/:slug',
      element: (
        <>
          <Header /> <BlogDetails /> <Footer />
        </>
      ),
    },
    {
      path: '/faq',
      element: (
        <>
          <Header /> <Faq /> <Footer /> <SocialIcon />
        </>
      ),
    },
  ]);

  return <>{loading ? <Preloader /> : <RouterProvider router={router} />}</>;
};

export default App;
